import React, { useEffect } from 'react'
import aboutImg from '../../img/about-2.png';
import aboutImg2 from '../../img/about.png';
import Aos from 'aos'
import 'aos/dist/aos.css'
import { Link } from 'react-router-dom';

export default function About() {
    useEffect(() => {
        Aos.init({
            duration: 1000
        })
    }, [])
    
    return (
        <>
          {/* Header Section */}
          <div className="page-header pb-5">
            <div className="container text-center py-5">
                <h1 className="display-4 text-uppercase mb-3 animated slideInDown text-light">About MARSHAL</h1>
                <nav aria-label="breadcrumb animated slideInDown">
                    <ol className="breadcrumb justify-content-center text-uppercase mb-0">
                        <li className="breadcrumb-item">
                            <Link className="text-white" to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link className="text-white" to="/about">Pages</Link>
                        </li>
                        <li className="breadcrumb-item text-primary active" aria-current="page">About</li>
                    </ol>
                </nav>
            </div>
          </div>

          {/* Company Overview Section */}
          <div className="container-fluid py-5">
            <div className="container">
              <div className="section-title text-center">
                <h4 className="text-primary text-uppercase" style={{letterSpacing: '5px'}}>Our Journey</h4>
                <h1 className="display-4">Since 2001</h1>
              </div>
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="p-4">
                    <h2 className="mb-4">MARSHAL Herbs Foundation</h2>
                    <p className="mb-4">
                      MARSHAL Herbs was founded in 2001 to produce safe and wholesome herbs and spices suitable 
                      for export to the local market and other exporters.
                    </p>
                    <p className="mb-4">
                      By joining of new members to MARSHAL Herbs team with prolonged experience in quality, 
                      production and export of herbs and spices complying with different customers' requirements 
                      and quality standards, MARSHAL Herbs start exporting and become one of the promising companies in the market.
                    </p>
                    <p>
                      The dedication of our employees, scale of our manufacturing and support operations, 
                      long-term industry experience of our management team, and our continuing focus on producing 
                      superior products, have helped us attain significant performance advantages in our marketplace.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img className="img-fluid rounded" src={aboutImg} alt="MARSHAL Herbs facility" />
                </div>
              </div>
            </div>
          </div>

          {/* Story Behind the Name Section */}
          <div className="container-fluid bg-light py-5">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <img className="img-fluid rounded" src={aboutImg2} alt="MARSHAL Herbs team" />
                </div>
                <div className="col-lg-6">
                  <div className="p-4">
                    <h2 className="text-primary mb-4">Story Behind the Name</h2>
                    <h4 className="mb-3">MARSHAL Herbs is Specific Motivated Advanced Reliable Group</h4>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Specific:</strong> MARSHAL Herbs owners are three partners who have more than 20 years worth of experience in the field of herbs and spices covering all the products' life cycle from plantation to export which makes them Specific.</h6>
                    </div>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Motivated:</strong> MARSHAL Herbs team plans to lead the Egyptian market of herbs and spices specially organic products through scientific and marketing studies which makes them Motivated.</h6>
                    </div>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Advanced:</strong> MARSHAL Herbs use the most advanced equipments in production and packaging of herbs and spices and also the most advanced studies in sustainability and food safety which makes them Advanced.</h6>
                    </div>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Reliable:</strong> MARSHAL Herbs guarantees: systematic analyses, strict controls, cleaning procedures, after-sales guarantees. These are all aspects that make our products absolutely Reliable.</h6>
                    </div>
                    
                    <p className="mb-0">
                      <strong>MARSHAL Herbs Group</strong> is composed of our employees, our customers and our suppliers, 
                      this is our Specific, Motivated, Advanced, and Reliable Group.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vision & Mission Section */}
          <div className="container-fluid py-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-5">
                  <div className="p-4 bg-primary text-white rounded">
                    <h2 className="mb-4">Our Vision</h2>
                    <p className="mb-4">
                      At MARSHAL Herbs, our vision is to become a leading global supplier of premium quality 
                      herbs and spices, while fostering a culture of teamwork and collaboration among our 
                      employees, customers, and partners.
                    </p>
                    <p>
                      We envision a world where natural, high-quality herbs and spices are accessible to all, 
                      while maintaining the highest standards of sustainability and ethical practices.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="p-4 border rounded">
                    <h2 className="mb-4 text-primary">Our Mission</h2>
                    <p className="mb-4">
                      Our mission is to achieve our vision by consistently delivering superior products and 
                      services that exceed the expectations of our customers and stakeholders.
                    </p>
                    <p className="mb-4">
                      We are committed to upholding the highest standards of integrity, ethics, and social 
                      responsibility in all of our business activities. As a team, we strive to create a 
                      positive and inclusive workplace where our employees can grow, develop, and contribute 
                      to our shared success.
                    </p>
                    <p className="mb-0">
                      Together, we will continue to lead the way in the production and export of safe, 
                      wholesome, and sustainable herbs and spices.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Responsibility & Commitment Section */}
          <div className="container-fluid bg-dark py-5">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="p-4 text-white">
                    <h2 className="mb-4 text-primary">Responsibility & Commitment</h2>
                    <p className="mb-4">
                      MARSHAL Herbs has a long tradition of responsibility – to our employees, our partners, 
                      and to society. This responsibility is a precondition and also a result of a value-oriented 
                      approach to corporate management.
                    </p>
                    <p className="mb-4">
                      Our entrepreneurial activities are guided by the principles of the United Nations Global Compact. 
                      In our daily work, it goes without saying that we comply with all applicable laws and respect 
                      and act in accordance with basic ethical values.
                    </p>
                    <p className="mb-4">
                      Beyond this, we have worked with our employees and business partners to develop principles 
                      and policies that specifically commit us to respecting and safeguarding human and labour 
                      rights as well as protecting the environment and counteracting corruption.
                    </p>
                    <p className="mb-0">
                      <strong>Our commitment</strong> is that our corporate responsibility doesn't end at the factory gates. 
                      In close cooperation with our suppliers and partners, we work towards implementing the labour, 
                      social and environmental standards we uphold, across the supply chain.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img className="img-fluid rounded" src={aboutImg} alt="MARSHAL Herbs responsibility" />
                </div>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="container-fluid py-5">
            <div className="container">
              <div className="section-title text-center mb-5">
                <h4 className="text-primary text-uppercase" style={{letterSpacing: '5px'}}>Our Achievements</h4>
                <h1 className="display-4">MARSHAL in Numbers</h1>
              </div>
              <div className="row g-4">
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-globe text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Global Markets</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">25</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>Countries Served</small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-users text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Team Members</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">50</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>Dedicated Professionals</small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-award text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Quality Standards</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">15</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>International Certificates</small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-leaf text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Product Range</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">100</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>Herbs & Spices</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="container-fluid py-5 bg-primary">
            <div className="container text-center">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <h2 className="text-white mb-4">Ready to Partner with MARSHAL?</h2>
                  <p className="text-white mb-5">
                    Join our network of satisfied customers and experience the MARSHAL difference in quality, 
                    reliability, and service excellence.
                  </p>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Link to="/products" className="btn btn-light btn-lg w-100">
                        View Our Products
                      </Link>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Link to="/contact" className="btn btn-outline-light btn-lg w-100">
                        Contact Us Today
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
    )
}